import formatDecimal from 'src/compass/shared/util/formatDecimal';
import ICasRenderCellProps from '../ICasRenderCellProps';
import getCasTableCellValue from '../getCasTableCellValue';

export function CasRenderDecimal(props: ICasRenderCellProps) {
  const value = getCasTableCellValue(props);

  return value != null && formatDecimal(value);
}
